import { Camera, ImagePlus, X } from 'lucide-react'
import React from 'react'
import { Button, Typogaphy } from 'vnetwork-ui'

interface UploadStepProps {
    files: File[]
    scanning: boolean
    onDrop: (e: React.DragEvent) => void
    onFilesAdd: (files: FileList) => void
    onRemoveFile: (idx: number) => void
    onScan: () => void
    onClose: () => void
    t: (key: string) => string
    tGlobal: (key: string) => string
}

const ScanCardUploadStep: React.FC<UploadStepProps> = ({
    files,
    scanning,
    onDrop,
    onFilesAdd,
    onRemoveFile,
    onScan,
    onClose,
    t,
    tGlobal,
}) => (
    <div className="space-y-4">
        {/* Drop zone */}
        <div
            className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center cursor-pointer hover:border-blue-400 hover:bg-blue-50/30 transition-colors"
            onDragOver={(e) => e.preventDefault()}
            onDrop={onDrop}
            onClick={() => document.getElementById('scan-card-input')?.click()}
        >
            <ImagePlus className="w-10 h-10 mx-auto text-gray-400 mb-3" />
            <Typogaphy className="text-sm text-gray-600 font-medium">
                {t('scan_card.drag_drop')}
            </Typogaphy>
            <Typogaphy className="text-xs text-gray-400 mt-1">
                {t('scan_card.max_files')}
            </Typogaphy>
            <input
                id="scan-card-input"
                type="file"
                multiple
                accept="image/jpeg,image/png"
                className="hidden"
                onChange={(e) => e.target.files && onFilesAdd(e.target.files)}
            />
        </div>

        {/* File previews */}
        {files.length > 0 && (
            <div className="grid grid-cols-5 gap-2">
                {files.map((f, i) => (
                    <div
                        key={i}
                        className="relative group rounded-md overflow-hidden border"
                    >
                        <img
                            src={URL.createObjectURL(f)}
                            alt={f.name}
                            className="w-full h-20 object-cover"
                        />
                        <button
                            type="button"
                            className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-0.5 opacity-0 group-hover:opacity-100 transition-opacity"
                            onClick={(e) => {
                                e.stopPropagation()
                                onRemoveFile(i)
                            }}
                        >
                            <X className="w-3 h-3" />
                        </button>
                        <div className="absolute bottom-0 left-0 right-0 bg-black/50 px-1 py-0.5">
                            <span className="text-[10px] text-white truncate block">
                                {f.name}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        )}

        {/* Actions */}
        <div className="flex justify-end gap-2 pt-2">
            <Button variant="outlined" onClick={onClose}>
                {tGlobal('cancel')}
            </Button>
            <Button
                variant="contained"
                onClick={onScan}
                disabled={!files.length || scanning}
                loading={scanning}
                startIcon={<Camera className="w-4 h-4" />}
            >
                {scanning ? t('scan_card.scanning') : t('scan_card.title')}
            </Button>
        </div>
    </div>
)

export default ScanCardUploadStep
